import React from "react";
import { Box, InputAdornment } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Controller } from "react-hook-form";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";
import { DesignTooltip } from "@ui/components/tooltip/DesignTooltip";
/** Whether a contact's phone field holds a number (the bare "+31" prefix the field starts with does not count). */
export const hasPhoneNumber = (value) => {
    const digits = (value !== null && value !== void 0 ? value : "").replace(/\s/g, "");
    return digits.length > 0 && digits !== "+31";
};
/**
 * The WhatsApp opt-in of one contact, shown inside its phone number field (super admins only): a small WhatsApp chip
 * that toggles on click — green when the owner of the number agreed to receive WhatsApp alarms, grey when not.
 * Use it as the phone field's end adornment.
 */
export const WhatsAppOptInChip = ({ name, control, disabled = false }) => {
    const { t } = useTranslation(["common"]);
    return (React.createElement(Controller, { name: name, control: control, render: ({ field }) => {
            const on = !!field.value && !disabled;
            const label = on ? t("common:labels.whatsAppOn") : t("common:labels.whatsAppOff");
            return (React.createElement(InputAdornment, { position: "end" },
                React.createElement(DesignTooltip, { maxWidth: 280, title: disabled ? t("common:labels.whatsAppAddNumberFirst") : t("common:labels.whatsAppOptInTooltip") },
                    React.createElement(Box, { component: "span", sx: { display: "inline-flex" } },
                        React.createElement(Box, { component: "button", type: "button", role: "switch", "aria-checked": on, "aria-label": `WhatsApp: ${label}`, disabled: disabled, onClick: () => field.onChange(!field.value), sx: (theme) => (Object.assign(Object.assign({ display: "inline-flex", alignItems: "center", gap: 0.5, height: 26, px: 1, borderRadius: "999px", border: "1px solid", fontSize: 12, fontWeight: 500, lineHeight: 1, whiteSpace: "nowrap", cursor: disabled ? "not-allowed" : "pointer", transition: theme.transitions.create(["background-color", "border-color", "color"]) }, (on
                                ? {
                                    bgcolor: alpha(theme.palette.success.main, 0.12),
                                    borderColor: alpha(theme.palette.success.main, 0.4),
                                    color: theme.palette.success.dark,
                                }
                                : {
                                    bgcolor: "transparent",
                                    borderColor: theme.palette.divider,
                                    color: disabled ? theme.palette.text.disabled : theme.palette.text.secondary,
                                })), { "&:hover": disabled
                                    ? undefined
                                    : { borderColor: on ? theme.palette.success.main : theme.palette.text.secondary }, "&:focus-visible": { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 } })) },
                            React.createElement(Icon, { icon: "ic:baseline-whatsapp", width: 16, height: 16 }),
                            label)))));
        } }));
};
export default WhatsAppOptInChip;
